import { useTranslation } from 'react-i18next';
import { Modal } from '@spotnana/blocks/src/Modal';

import { ErrorMessage } from './styles';
import useSupportWidget from '../../../../../../hooks/useSupportWidget';

interface IProps {
  onClose: VoidFunction;
}

const BookingFailedAlertModal = ({ onClose }: IProps): JSX.Element => {
  const { t: tt } = useTranslation('WEB');
  const { openChatWidget } = useSupportWidget();

  const handleContactUs: VoidFunction = () => {
    onClose();
    openChatWidget();
  };

  return (
    <Modal
      open
      onClose={onClose}
      data-testId="modal_booking-failed-alert"
      variant="medium"
      header={{ title: tt('Booking Failed') }}
      footer={{
        primaryAction: {
          text: tt('Contact us'),
          onClick: handleContactUs,
        },
        secondaryAction: {
          text: tt('Cancel'),
          onClick: onClose,
        },
      }}
    >
      <ErrorMessage>
        {tt('Something went wrong, please try again in a few minutes. If the issue persists contact an agent.')}
      </ErrorMessage>
    </Modal>
  );
};

export default BookingFailedAlertModal;
